var _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-double-ring",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    "ng-attr-r": "{{config.radius}}",
    "ng-attr-stroke-width": "{{config.width}}",
    "ng-attr-stroke": "{{config.c1}}",
    "ng-attr-stroke-dasharray": "{{config.dasharray}}",
    fill: "none",
    strokeLinecap: "round",
    r: 40,
    strokeWidth: 3,
    stroke: "currentColor",
    strokeDasharray: "62.83185307179586 62.83185307179586",
    transform: "rotate(259.874 50 50)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: "1.5s",
    begin: "0s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    "ng-attr-r": "{{config.radius2}}",
    "ng-attr-stroke-width": "{{config.width}}",
    "ng-attr-stroke": "{{config.c2}}",
    "ng-attr-stroke-dasharray": "{{config.dasharray2}}",
    "ng-attr-stroke-dashoffset": "{{config.dashoffset2}}",
    fill: "none",
    strokeLinecap: "round",
    r: 36,
    strokeWidth: 3,
    stroke: "#d8e4ff",
    strokeDasharray: "56.548667764616276 56.548667764616276",
    strokeDashoffset: 56.548667764616276,
    transform: "rotate(-259.874 50 50)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 50 50;-360 50 50",
    keyTimes: "0;1",
    dur: "1.5s",
    begin: "0s",
    repeatCount: "indefinite"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.d0766d9846723ecb2f4d37f55bc82118.svg";
export { ForwardRef as ReactComponent };